module.exports = __webpack_public_path__ + "img/icon_pwd_forget.d411be6b.png";